/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function ApplicationTableConfig($q, $translate, $mdDialog, $document, $state, toast, types, utils, tkDialogs, userService,
                                           applicationService, networkSettingsService, apiLimitsService, subCustomerService) {

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(params) {

        var deferred = $q.defer();

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;

        if (params.subCustomerId) {
            subCustomerService.getSubCustomer(params.subCustomerId).then(
                (subCustomer) => {
                    var tableConfiguration = createApplicationConfig(scope, access, params, subCustomer.title);
                    deferred.resolve(tableConfiguration);
                },
                () => {
                    deferred.reject();
                }
            );
        } else {
            var tableConfiguration = createApplicationConfig(scope, access, params);
            deferred.resolve(tableConfiguration);
        }
        return deferred.promise;
    }

    function createApplicationConfig(scope, access, params, entityTitle) {

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var subCustomerId;

        if (params.subCustomerId) {
            subCustomerId = params.subCustomerId;
        } else {
            subCustomerId = currentUser.subCustomerId;
        }

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.application,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                { key: 'createdTime',
                    title: 'entity.createdTime'},
                { key: 'name',
                    title: 'application.name'},
                { key: 'devicesCount',
                    title: 'application.number-of-devices'
                }
            ],

            addEntityController: 'AddApplicationController',

            loadEntities: () => {return scope == types.scope.customer && !params.subCustomerId
                ? applicationService.getCustomerApplications()
                : applicationService.getSubCustomerApplications(subCustomerId)},
            loadEntity: (entityId) => {return loadApplication(entityId)},
            saveEntity: (entity) => {return saveApplication(entity)},
            deleteEntity: (entityId) => {return applicationService.deleteApplication(entityId)},

            addEnabled: () => {
                return access == types.access.admin;
            },
            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('application.delete-application-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('application.delete-application-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('application.delete-applications-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('application.delete-applications-text');
            }

        };

        if (!params.subCustomerId && scope == types.scope.customer) {
            tableConfiguration.columns.push(
                {
                    key: 'subCustomerTitle',
                    title: 'application.assigned-subCustomer'
                }
            );
        }

        tableConfiguration.manageCredentials = (event, entity) => {
            var isReadOnly = access == types.access.user ? true : false;
            manageCredentials(event, entity, isReadOnly);
        };

        tableConfiguration.manageDevices = (event, entity) => {
            manageDevices(event, params.subCustomerId, entity);
        };

        tableConfiguration.actionCellDescriptors = [
            {
                name: 'application.assign-to-subCustomer',
                icon: 'assignment_ind',
                isEnabled: (entity) => {
                    return entity && (authority === types.authority.CUSTOMER_ADMIN.value && !params.subCustomerId && !entity.subCustomerId);
                },
                onAction: ($event, entity) => {
                    assignToCustomer($event, entity, tableConfiguration);
                }
            },
            {
                name: 'application.unassign-from-subCustomer',
                icon: 'assignment_return',
                isEnabled: (entity) => {
                    return entity && (authority === types.authority.CUSTOMER_ADMIN.value && (params.subCustomerId || entity.subCustomerId));
                },
                onAction: ($event, entity) => {
                    unassignFromCustomer($event, entity, tableConfiguration);
                }
            },
            {
                name: access == types.access.admin ? 'credentials.manage' : 'credentials.view',
                icon: 'security',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    var isReadOnly = types.adminAuthorities.indexOf(authority) === -1 ? true : false;
                    manageCredentials($event, entity, isReadOnly);
                }
            },
            {
                name: 'application.manage-devices',
                icon: 'devices_other',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    manageDevices($event, params.subCustomerId, entity);
                }
            },
            {
                name: 'application.manage-multicast-groups',
                icon: 'device_hub',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    manageMulticastGroups($event, params.subCustomerId, entity);
                }
            },
            {
                name: 'application.manage-integrations',
                icon: 'extension',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    manageIntegrations($event, params.subCustomerId, entity);
                }
            }
        ];

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function getTitle(scope, entityTitle) {
        var title = $translate.instant('application.applications');

        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + title;
        }
        return title;
    }

    function manageCredentials($event, application, isReadOnly) {
        tkDialogs.manageCredentials($event, application, isReadOnly);
    }

    function manageDevices($event, subCustomerId, application) {
        if ($event) {
            $event.stopPropagation();
        }
        if (subCustomerId) {
            $state.go('home.subCustomers.applications.devices', {subCustomerId: subCustomerId, applicationId: application.id.id});
        } else {
            $state.go('home.applications.devices', {applicationId: application.id.id});
        }
    }

    function manageMulticastGroups($event, subCustomerId, application) {
        if ($event) {
            $event.stopPropagation();
        }
        if (subCustomerId) {
            $state.go('home.subCustomers.applications.multicastGroups', {subCustomerId: subCustomerId, applicationId: application.id.id});
        } else {
            $state.go('home.applications.multicastGroups', {applicationId: application.id.id});
        }
    }

    function manageIntegrations($event, subCustomerId, application) {
        if ($event) {
            $event.stopPropagation();
        }
        if (subCustomerId) {
            $state.go('home.subCustomers.applications.integrations', {subCustomerId: subCustomerId, applicationId: application.id.id});
        } else {
            $state.go('home.applications.integrations', {applicationId: application.id.id});
        }
    }

    function assignToCustomer($event, application, tableConfiguration) {
        var onEntitySelected = (targetSubCustomerId) => {
            return applicationService.assignApplicationToSubCustomer(targetSubCustomerId.id, application.id.id);
        };
        tkDialogs.selectEntity($event, types.entityType.subCustomer,
            'application.assign-application', 'action.assign',
            'application.select-target-assign-subCustomer-text',
            'subCustomer.subCustomer-not-found-text',
            'subCustomer.target-subCustomer-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function unassignFromCustomer($event, application, tableConfiguration) {
        var title = $translate.instant('application.unassign-application-title', {applicationName: application.name});
        var content = $translate.instant('application.unassign-application-text');
        var label = $translate.instant('application.unassign-application');

        tkDialogs.confirm($event, title, content, label).then(
            () => {
                applicationService.unassignApplicationFromSubCustomer(application.id.id).then(
                    () => { tableConfiguration.reloadEntities(true); }
                );
            }
        );
    }

    function loadApplication(applicationId) {
        var deferred = $q.defer();
        applicationService.getApplication(applicationId).then(
            (application) => {
                networkSettingsService.getNetworkSettings(types.entityType.application, applicationId).then(
                    (networkSettings) => {
                        application.networkSettings = networkSettings;
                        apiLimitsService.getApiLimits(types.entityType.application, applicationId).then(
                            (apiLimits) => {
                                application.apiLimits = apiLimits;
                                deferred.resolve(application);
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function saveApplication(application) {
        var deferred = $q.defer();
        var networkSettings = application.networkSettings;
        var apiLimits = application.apiLimits;
        applicationService.saveApplication(application).then(
            (application) => {
                networkSettingsService.saveNetworkSettings(networkSettings).then(
                    (networkSettings) => {
                        application.networkSettings = networkSettings;
                        apiLimitsService.saveApiLimits(apiLimits).then(
                            (apiLimits) => {
                                application.apiLimits = apiLimits;
                                deferred.resolve(application);
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }


}



// WEBPACK FOOTER //
// ./src/app/application/application-table.config.js